import React from "react";
import { useForm } from "react-hook-form";
import { DataContext } from "../../../../../state/DataContext/DataContext";
import { useParams } from "react-router-dom";
import { Job } from "../../../../../typings/Job";
import { JobForm } from "../JobForm";
import { SuccesToast } from "../../../../Shared/ToastMessage/SuccessToast";
// var Select: any = require('react-select');

export default function AddJob(props: { Job?: Job, onClose?: any, afterEditFn?: any, isEdit?: boolean }) {

    const [isLoading, setIsLoading] = React.useState(false);
    const [fileArray, setFileArray] = React.useState([]);
    const [filesToBeDeleted, setFilesToBeDeleted] = React.useState([]);
    const [isSafeToRedirect, setIsSafeToRedirect] = React.useState(false);
    const { actions } = React.useContext(DataContext);
    let params = useParams<any>();

    const formControls = useForm({
        defaultValues: {} as Job,
    });

    const addJob = (values: Job, JobFiles: any) => {
        actions.Job.AddJob({ ...values, TenantID: params.tenantID, JobFiles: JobFiles }).then(() => {
            SuccesToast(values.Title)
            setIsSafeToRedirect(true)
            setIsLoading(false)
        })
    }

    const onSubmit = (values: any) => {
        setIsLoading(true)

        delete values.JobFiles;

        // Add
        if (fileArray.length > 0) {

            // Add all files and get URL
            var promises = fileArray.map(file => {
                return actions.Storage.AddFileAndGetFileObject(file)
            })

            // Get URL and store in JOB Db
            Promise.all(promises).then(function (JobFiles) {
                addJob(values, JobFiles)
            })

            if (props.onClose) { props.onClose() }
        }
        else {
            addJob(values, [])
            setIsLoading(false)

            setIsSafeToRedirect(true)
            if (props.onClose) { props.onClose() }
        }
    }

    return (

        <JobForm
            {...formControls}
            onSubmit={onSubmit}
            isLoading={isLoading}
            setFileArray={setFileArray}
            fileArray={fileArray}
            setFilesToBeDeleted={setFilesToBeDeleted}
            isSafeToRedirect={isSafeToRedirect}
            params
            errors={formControls.formState.errors}
        />

    );
}
